import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Avatar,
  Button,
  IconButton,
  Box, Switch, Popover, Pagination
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setUserForDelete,
  setUserForEdit,
  setUserForView,
} from "../../Slices/userslice";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
const UserTable = ({ userData = [], getUsers }) => {
  // const userData = user;
  const cellStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    textAlign: "left",
  };
  const dataStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "18px",
    textAlign: "left",
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userDetails, setUserDetails] = useState([]);
  const handleActionOpen = (event, userId, userDetails) => {
    setSelectedUserId(userId);
    setUserDetails(userDetails);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAction = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "table-options-popover" : undefined;
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#34C759",
          ...theme.applyStyles("dark", {
            backgroundColor: "#FF2800",
          }),
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "rgba(0,0,0,.25)",
      boxSizing: "border-box",
      ...theme.applyStyles("dark", {
        backgroundColor: "rgba(255,255,255,.35)",
      }),
    },
  }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleEdit = () => {
    dispatch(
      setUserForEdit({ user_id: selectedUserId, isEdit: true, table: true })
    );
    navigate("/home/adduser");
    handleCloseAction();
  };
  const handleDelete = () => {
    dispatch(
      setUserForDelete({ user_id: selectedUserId, isDelete: true, table: true })
    );
    navigate("/home/adduser");
    handleCloseAction();
  };
  const handleView = () => {
    dispatch(
      setUserForView({ user_id: selectedUserId, isView: true, table: true })
    );
    navigate("/home/adduser");
    handleCloseAction();
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='user table'>
          {/* Table Header */}
          <TableHead sx={{ backgroundColor: "#e0eaff", height: "50px" }}>
            <TableRow>
              <TableCell sx={cellStyle}>User Name</TableCell>
              <TableCell sx={cellStyle}>Email ID</TableCell>
              <TableCell sx={cellStyle}>Role</TableCell>
              <TableCell sx={cellStyle}>Phone Number</TableCell>
              <TableCell sx={cellStyle}>Skill Set</TableCell>
              <TableCell sx={cellStyle}>Projects Associated</TableCell>
              <TableCell sx={cellStyle}>Actions</TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {userData.map((user, index) => (
              <TableRow key={user.user_id}>
                <TableCell sx={dataStyle}>{user.user_name}</TableCell>
                <TableCell sx={dataStyle}>{user.email}</TableCell>
                <TableCell sx={dataStyle}>{user?.role || "User"}</TableCell>
                <TableCell sx={dataStyle}>{user?.phone_number}</TableCell>
                <TableCell sx={dataStyle}>{user?.skill_set}</TableCell>
                <TableCell>
                  <Box display='flex' alignItems='center'>
                    <Typography sx={dataStyle}>
                      +{" "}
                      {user && user.plan_count}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <IconButton
                    aria-label='more options'
                    onClick={(event) =>
                      handleActionOpen(event, user.user_id, user)
                    }>
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseAction}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}>
        <Box sx={{ p: 1, width: "130px" }}>
          <Button
            onClick={handleView}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none", // to keep the text lowercase

              color: "black", // you can adjust color as needed
            }}>
            <VisibilityIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='view-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              View User
            </Typography>
          </Button>
          <Button
            onClick={handleEdit}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",

              color: "black",
            }}>
            <EditIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='edit-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              Edit User
            </Typography>
          </Button>

          <Button
            onClick={handleDelete}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",

              color: "black",
            }}>
            <DeleteIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='delete-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              Delete User
            </Typography>
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default UserTable;
